"use strict";
exports.__esModule = true;
exports.ChildStatus = void 0;
var ChildStatus;
(function (ChildStatus) {
    ChildStatus["REFERRAL_CREATED"] = "Referral";
    ChildStatus["FRC_ASSIGNED"] = "Initial IFSP";
    // ...
    ChildStatus["TRANSITIONED"] = "Exited";
})(ChildStatus = exports.ChildStatus || (exports.ChildStatus = {}));
//# sourceMappingURL=ChildListResult.js.map